<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <tags-view />
      <app-main style="padding-bottom: 80px;"></app-main>
      <div class="copyright">© 2024 CNI（CHINA）CO.LTD. All Rights Reserved ⋅ 鲁ICP备12031714号</div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  
  .copyright {
    text-align: center;
    font-size: 12px;
    color: #999;
    padding: 10px 0;
    width: calc(100% - 180px);
    position: fixed;
    bottom: 0;
    left: 180px;
    background-color: #fff;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue